import { FormattedMessage, useIntl } from "react-intl";

import { transformChunks } from "shared/components/TextWrapper";
import { YesNoModal, YesNoModalProps } from "shared/components/YesNoModal";

export type NoMatchingListModalProps = Pick<YesNoModalProps, "onClickYes" | "onClickNo">;

export function NoMatchingListModal({ onClickYes, onClickNo }: NoMatchingListModalProps) {
  const intl = useIntl();
  return (
    <YesNoModal
      isOpen
      onClickYes={onClickYes}
      onClickNo={onClickNo}
      title={intl.formatMessage({
        id: "components.no-matching-list-modal.title",
      })}
      body={
        <FormattedMessage
          id="components.no-matching-list-modal.body"
          values={transformChunks({ b: { as: "strong" } })}
        />
      }
      yesLabel={intl.formatMessage({
        id: "flows.inbound.page.inbound-shared-list.button",
      })}
      noLabel={intl.formatMessage({
        id: "generic.actions.cancel",
      })}
      isGrey
    />
  );
}
